<template>
  <div class="view-wrapper">

    <div class="search-container elevation-1 white px-3 pt-2 pb-2 d-flex flex-column">
      
      <v-radio-group 
        v-model="tipoBusca" 
        row 
        hide-details 
        class="mt-0 mb-3" 
        @change="focarInputBusca"
      >
        <v-radio label="Código" value="codigo" color="primary"></v-radio>
        <v-radio label="Descrição" value="descricao" color="primary"></v-radio>
      </v-radio-group>

      <div class="d-flex align-center" style="width: 100%;">
        <v-text-field
          ref="campoBusca"
          v-model="termoBusca"
          :label="labelBusca"
          outlined
          dense
          clearable
          hide-details
          class="mr-2"
          @keydown.enter="forcarBusca('qualquer')"
        ></v-text-field>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2 mr-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('inicio')"
          title="Buscar pelo Início"
        >
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>

        <v-btn 
          height="40"
          width="70"
          min-width="40"
          class="px-2"
          color="primary" 
          elevation="2" 
          @click="forcarBusca('qualquer')"
          title="Buscar em Qualquer Parte"
        >
          <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="content-container elevation-2">
      <div v-if="loading" class="text-center pa-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <p class="mt-4 mb-0 ">{{ textoLoading }}</p>
      </div>

      <div v-else-if="!loading && resultados.length === 0" class="text-center pa-8">
        <p class="mb-0">Nenhum resultado encontrado.</p>
      </div>

      <RecycleScroller
        v-else
        ref="scrollerComponent"  class="scroller" 
        :items="resultados"
        :item-size="100" 
        :buffer="1000"  key-field="proidcortamanhofinal"
        v-slot="{ item }"
      >
        <v-list-item
          class="list resultado-item-clicavel px-2"
          :class="{ 'item-selecionado': itemSelecionado === item }"
          style="height: 100px; border-bottom: 1px solid #e0e0e0;"
          @click="selecionarEVoltar(item)"
          v-intersect.once="{
            handler: (entries, observer, isIntersecting) => {
              if(isIntersecting) carregarImagemItem(item)
            }
          }"
        >
          <v-list-item-content>
            <v-list-item-title 
              class="dado-destacado3 font-weight-medium text-wrap text-justify" 
              style="height: auto; max-height: 48px; overflow: hidden; line-height: 1.2rem;"
            >
              {{ item.proidcortamanhofinal }} - {{ item.prodescricao }}
            </v-list-item-title>
            
            <v-list-item-subtitle class="dado-destacado4 mt-1">
              Grupo: <span class="font-weight-medium">{{ item.grudescricao || item.grupo || 'N/A' }}</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle class="mt-1 d-flex align-center"> 
              
              <span v-if="item.proean" class="dado-destacado2 grey--text text--darken-1">
                EAN: {{ item.proean }}
              </span>

              <span v-if="item.proreferencia" class="dado-destacado2 ml-4 grey--text text--darken-1">
                Ref: {{ item.proreferencia }}
              </span>

              <span v-if="item.provalor" class="dado-destacado2 ml-4 grey--text text--darken-1">
                PREÇO: {{ item.provalor }}
              </span>
            </v-list-item-subtitle>

          </v-list-item-content>

        </v-list-item>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import db from '@/plugins/dexie';
import storage from '@/services/storage';

Vue.use(VueVirtualScroller)

export default {
  name: 'ViewCadastroPedidoProduto',
  
  data() {
    return {
      idPedido: this.$route.query.idpedido || null,
      idCliente: this.$route.query.idcliente || null,
      
      termoBusca: this.$route.query.busca || '',
      tipoBusca: this.$route.query.tipoBusca || 'descricao', 
      modoBusca: this.$route.query.modoBusca || 'qualquer',

      loading: false, 
      loadingInicial: true, 
      textoLoading: 'Carregando dados locais...',
      itemSelecionado: null,
      resultados: [], 
      previousRouteName: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    let originalFrom = from.name;
    if (from.name !== 'pesquisa-filtro-produto') {
      sessionStorage.setItem('indexProdutoOrigin', from.name);
      originalFrom = from.name;
    } else {
      originalFrom = sessionStorage.getItem('indexProdutoOrigin');
    }
    next(vm => {
      vm.previousRouteName = originalFrom;
    });
  },

  beforeRouteLeave(to, from, next) {
    if (this.$refs.scrollerComponent && this.$refs.scrollerComponent.$el) {
      const scrollPos = this.$refs.scrollerComponent.$el.scrollTop;
      sessionStorage.setItem('listaProdutosScrollPos', scrollPos);
    }

    if (to.name !== 'pesquisa-filtro-produto') {
      sessionStorage.removeItem('indexProdutoOrigin');
      storage.removeItem('filtro_produto_texto');
    }
    next();
  },

  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(novoQuery, antigoQuery) {
        if (novoQuery.idpedido) this.idPedido = novoQuery.idpedido;
        if (novoQuery.idcliente) this.idCliente = novoQuery.idcliente;
        if (novoQuery.tipoBusca) this.tipoBusca = novoQuery.tipoBusca;
        if (novoQuery.modoBusca) this.modoBusca = novoQuery.modoBusca;
        
        if (novoQuery.busca !== this.termoBusca) {
          this.termoBusca = novoQuery.busca || '';
        }

        if (!antigoQuery) {
          this.iniciarProcesso();
          return;
        }
        
        const mudouBusca = novoQuery.busca !== antigoQuery.busca;
        const mudouCategoria = novoQuery.idgrupo !== antigoQuery.idgrupo;
        const mudouTipo = novoQuery.tipoBusca !== antigoQuery.tipoBusca;
        const mudouModo = novoQuery.modoBusca !== antigoQuery.modoBusca;
        
        if (mudouBusca || mudouCategoria || mudouTipo || mudouModo) {
          this.iniciarProcesso();
        } 
        else if (novoQuery.selecionadoId !== antigoQuery.selecionadoId) {
          this.restaurarSelecaoDaUrl();
        }
      },
    },
  },

  computed: {
    veioDeTelaEspecifica() {
      return this.previousRouteName === 'cadastro-pedido-item';
    },
    labelBusca() {
      return this.tipoBusca === 'codigo' ? 'Buscar por Código' : 'Buscar por Descrição';
    }
  },

  methods: {
    focarInputBusca() {
      this.$nextTick(() => {
        if (this.$refs.campoBusca) {
          this.$refs.campoBusca.focus();
          const nativeInput = this.$refs.campoBusca.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.select();
          }
        }
      });
      if (this.termoBusca && this.termoBusca.trim() !== '') {
        this.forcarBusca();
      }
    },

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    forcarBusca(modoSelecionado = null) {
      if (modoSelecionado) {
        this.modoBusca = modoSelecionado;
      }
      
      const query = { ...this.$route.query };
      const buscaLimpa = this.termoBusca ? this.termoBusca.trim() : '';

      if (buscaLimpa !== '') {
        query.busca = buscaLimpa;
        query.modoBusca = this.modoBusca;
      } else {
        delete query.busca;
        delete query.modoBusca;
      }

      query.tipoBusca = this.tipoBusca;

      if (this.$route.query.busca !== query.busca || 
          this.$route.query.tipoBusca !== query.tipoBusca ||
          this.$route.query.modoBusca !== query.modoBusca) {
        this.$router.replace({ query }).catch(() => {});
      } else {
        this.iniciarProcesso();
      }
    },

    async iniciarProcesso() {
      this.itemSelecionado = null;
      this.loading = true;
      this.loadingInicial = true; 

      await this.carregarPaginaVisualizacao();
      
      this.loadingInicial = false; 
      this.loading = false;

      this.restaurarPosicaoScroll();
    },

    restaurarPosicaoScroll() {
      const posSalva = sessionStorage.getItem('listaProdutosScrollPos');
      
      if (posSalva && this.resultados.length > 0) {
        this.$nextTick(() => {
          setTimeout(() => {
            const scroller = this.$refs.scrollerComponent;
            
            if (scroller && scroller.$el) {
              const posicao = parseInt(posSalva);
              
              scroller.$el.scrollTop = posicao;
              this.carregarImagensDaAreaVisivel(posicao);
            }
          }, 100);
        });
      } else {
        this.carregarImagensDaAreaVisivel(0);
        setTimeout(() => {
          this.carregarRestoEmBackground(0);
        }, 1000);
      }
    },

    carregarImagensDaAreaVisivel(scrollTopAtual) {
      if (!this.resultados.length) return;

      const scrollerEl = this.$refs.scrollerComponent ? this.$refs.scrollerComponent.$el : null;
      const alturaTela = scrollerEl ? scrollerEl.clientHeight : window.innerHeight;
      const alturaItem = 100;

      const indiceInicial = Math.floor(scrollTopAtual / alturaItem);
      const indiceFinal = Math.ceil((scrollTopAtual + alturaTela) / alturaItem) + 2;

      const inicioSeguro = Math.max(0, indiceInicial - 2);
      const fimSeguro = Math.min(this.resultados.length - 1, indiceFinal);

      for (let i = inicioSeguro; i <= fimSeguro; i++) {
        const item = this.resultados[i];
        if (item && !item.imagemUrl && !item.imagemCarregando) {
          this.carregarImagemItem(item);
        }
      }

      setTimeout(() => {
        this.carregarRestoEmBackground(fimSeguro + 1);
      }, 1000);
    },

    async carregarRestoEmBackground(indiceComeco) {
      const tamanhoLote = 5;

      if (indiceComeco >= this.resultados.length) return;

      const lote = this.resultados.slice(indiceComeco, indiceComeco + tamanhoLote);
      
      const promessas = lote.map(item => {
        if (item.imagemUrl) return Promise.resolve();
        return this.carregarImagemItem(item);
      });

      await Promise.all(promessas);

      setTimeout(() => {
        this.carregarRestoEmBackground(indiceComeco + tamanhoLote);
      }, 100); 
    },
    
    async carregarPaginaVisualizacao() {
      try {
        const { busca, idgrupo, tipoBusca, modoBusca } = this.$route.query;
        const filtroGrupoId = idgrupo ? Number(idgrupo) : null;
        
        const termoTerm = (this.termoBusca || busca || '').toLowerCase().trim();
        const filtroBusca = termoTerm !== '' ? termoTerm : null;
        const tipoBuscaAtivo = this.tipoBusca || tipoBusca || 'descricao';
        const modoBuscaAtivo = this.modoBusca || modoBusca || 'qualquer';

        let produtos = await db.produto.toArray();

        if (filtroGrupoId) {
          produtos = produtos.filter(p => p.proidgrupo === filtroGrupoId || p.idgrupo === filtroGrupoId);
        }

        if (filtroBusca) {
          produtos = produtos.filter(p => {
            let match = true;
            const termoBuscaAcento = this.removerAcentos(filtroBusca);

            if (tipoBuscaAtivo === 'descricao') {
              const desc = p.prodescricao || p.descricao || '';
              const descLimpa = this.removerAcentos(desc.toLowerCase());
              
              if (modoBuscaAtivo === 'inicio') {
                if (!descLimpa.startsWith(termoBuscaAcento)) match = false;
              } else {
                if (!descLimpa.includes(termoBuscaAcento)) match = false;
              }
            } 
            else if (tipoBuscaAtivo === 'codigo') {
              const codigosPossiveis = [
                p.proidcortamanhofinal,
              ].filter(v => v !== null && v !== undefined).map(v => v.toString().toLowerCase().trim());

              if (modoBuscaAtivo === 'inicio') {
                match = codigosPossiveis.some(cod => cod.startsWith(termoBuscaAcento));
              } else {
                match = codigosPossiveis.some(cod => cod.includes(termoBuscaAcento));
              }
            }
            return match;
          });
        }
        
        this.resultados = produtos.map(p => this.mapearProdutoParaView(p));
        this.restaurarSelecaoDaUrl();
        
        return true;

      } catch (e) {
        console.error("Erro load:", e);
        return false;
      }
    },

    mapearProdutoParaView(p) {
      let urlImagemGerada = null;
      const blob = p.imgBlob1 || p.imgBlob2 || p.imgBlob3;

      if (blob) {
        try {
          let blobParaSalvar = blob;
          if (!(blob instanceof Blob)) {
            blobParaSalvar = new Blob([blob], { type: 'image/jpeg' });
          }
          urlImagemGerada = URL.createObjectURL(blobParaSalvar);
        } catch (e) {
          console.error("Erro ao converter blob inicial:", e);
        }
      }

      const idProduto = p.proidcortamanhofinal;
      const idNuvem = p.proidcortamanhofinal;
      const codigoInterno = p.procodigointerno;
      const descricao = p.prodescricao;
      const grupoDesc = p.grudescricao;
      const valor = p.provalor;
      const ean = p.proean;
      const referencia = p.proreferencia;
      const idGrupo = p.proidgrupo;

      return {
        // Nomes nativos da tabela Dexie (com prefixo pro_)
        proidproduto: idProduto,
        proidcortamanhofinal: idNuvem,
        procodigointerno: codigoInterno,
        prodescricao: descricao,
        grudescricao: grupoDesc,
        provalor: valor,
        proean: ean,
        proreferencia: referencia,
        proidgrupo: idGrupo,
        
        // Aliases para compatibilidade legada
        idproduto: idProduto, 
        idcortamanhofinal: idNuvem,
        codigo: codigoInterno,
        descricao: descricao,
        grupo: grupoDesc,
        preco: valor,
        ean: ean,
        referencia: referencia,
        idGrupo: idGrupo,
        
        imagemUrl: urlImagemGerada, 
        imagemCarregando: false,
      };
    },

    async carregarImagemItem(item) {
      if (item.imagemUrl || item.imagemCarregando) return;

      this.$set(item, 'imagemCarregando', true);

      const idChave = item.proidcortamanhofinal;
      let prodLocal = null;

      try {
        if (db.produto && idChave != null) {
          prodLocal = await db.produto.where('proidcortamanhofinal').equals(idChave).first()
                      || await db.produto.where('proidnuvem').equals(String(idChave)).first();
          
          if (prodLocal) {
            const blobLocal = prodLocal.imgBlob1 || prodLocal.imgBlob2 || prodLocal.imgBlob3;

            if (blobLocal) {
              const urlCache = URL.createObjectURL(blobLocal);
              this.$set(item, 'imagemUrl', urlCache);
              this.$set(item, 'imagemCarregando', false);
              return;
            }
          }
        }
      } catch (e) { 
        console.warn("Erro ao ler Dexie:", e); 
      }
      
      try {
        const idParaBusca = idChave;
        const blob = await this.fetchImagem({ id: idParaBusca, indice: 1 });
        
        if (blob && (blob.size > 0 || blob.byteLength > 0)) {
          let blobParaSalvar = blob;
          if (!(blob instanceof Blob)) {
            blobParaSalvar = new Blob([blob], { type: 'image/jpeg' });
          }
          const urlCriada = URL.createObjectURL(blobParaSalvar);
          this.$set(item, 'imagemUrl', urlCriada);
          if (db.produto && prodLocal && prodLocal.id) {
            db.produto.update(prodLocal.id, { 
                imgBlob1: blobParaSalvar,
                dataDownloadImagem: new Date()
            }).catch(()=>{});
          }
        } else {
          this.$set(item, 'imagemUrl', null); 
        }
      } catch (error) {
        this.$set(item, 'imagemUrl', null);
      } finally {
        this.$set(item, 'imagemCarregando', false);
      }
    },

    selecionarEVoltar(item) {
      if (!item) return;
      const idChave = item.proidcortamanhofinal;
      const codigo = item.procodigointerno || item.codigo;
      const descricao = item.prodescricao || item.descricao;
      const idGrupo = item.proidgrupo || item.idGrupo;
      const valor = item.provalor || item.preco;

      const dadosProduto = {
        id: idChave,
        proidcortamanhofinal: item.proidcortamanhofinal || idChave,
        proidproduto: item.proidproduto,
        procodigointerno: codigo,
        codigo: codigo,
        prodescricao: descricao,
        descricao: descricao,
        proidgrupo: idGrupo,
        idgrupo: idGrupo,
        provalor: valor,
        preco: valor
      };
      const dadosParaCadastro = {
        tipo: 'Produto',
        codigo: codigo,
        id: idChave,
        nome: descricao
      };
      sessionStorage.setItem('pesquisaResultado', JSON.stringify(dadosParaCadastro));
      sessionStorage.setItem('produto_selecionado_retorno', JSON.stringify(dadosProduto));
      sessionStorage.setItem('filtro_historico_produto', JSON.stringify(dadosProduto));
      this.$router.back();
    },

    async verificarRetornoStorage() {
      const retornoStr = sessionStorage.getItem('retornoSelecaoProduto');
      if (retornoStr) {
        try {
          sessionStorage.removeItem('retornoSelecaoProduto');
        } catch (e) { console.error(e); }
      }
    },
    
    acaoDetalhe() {
      if (!this.itemSelecionado) return;
      const idChave = this.itemSelecionado.proproidcortamanhofinalidnuvem || this.itemSelecionado.proidproduto || this.itemSelecionado.idcortamanhofinal;
      this.$router.push({
        path: '/pesquisa-filtro-produto',
        query: { 
          aba: 'detalhamento',
          produtoNome: this.itemSelecionado.prodescricao || this.itemSelecionado.descricao, 
          produtoId: idChave 
        },
      });
    },

    restaurarSelecaoDaUrl() {
      const { selecionadoId } = this.$route.query;
      if (selecionadoId && this.resultados.length > 0) {
        const idParaSelecionar = parseInt(selecionadoId);
        const itemEncontrado = this.resultados.find(p => (p.proidcortamanhofinal || p.proidproduto || p.idcortamanhofinal) === idParaSelecionar);
        if (itemEncontrado) this.itemSelecionado = itemEncontrado;
      }
    },
    
    formatarMoeda(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },
    formatarDecimal(valor, casas = 3) {
      if (typeof valor !== 'number') return '0';
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas });
    },
  },

  mounted() {
    if (!this.loadingInicial) {
      this.verificarRetornoStorage();
    }
  }
};
</script>

<style scoped>
.view-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);
}
.content-container {
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.botoes-topo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  width: 100%;
  background-color: white;
  flex-shrink: 0;
} 

.scroller {
  height: 100%;
  overflow-y: auto;
}
.scroller::-webkit-scrollbar {
  width: 12px;
}
.scroller::-webkit-scrollbar-thumb {
  background: rgba(76, 111, 175, 0.4);
  border-radius: 4px;
}
.scroller::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}

.item-selecionado {
  background-color: #E3F2FD !important;
}
.botao-topo {
  flex-grow: 1;
  margin: 0 4px;
}
.dado-destacado {
  color: #1976D2;
  font-size: 0.85rem;
}
.dado-destacado2 {
  font-size: 0.80rem;
}

.dado-destacado4 {
  font-size: 0.85rem;
  color: #616161;
}

.dado-destacado3 {
  font-size: 1rem;
}
.icon-img {
  height: 24px;
  width: 24px; 
  filter: brightness(0) invert(1);
}
.list{
  background-color: white;
}
.border-radius-circle{
  border: #ccc 1px solid;
}

::v-deep .v-input--radio-group__input {
  display: flex;
  width: 100%;
}
::v-deep .v-radio {
  margin-right: 16px !important;
}
</style>